import { createFileRoute } from "@tanstack/react-router";
import { AdminOrgPlanPage } from "@/features/admin/org-plan";

export const Route = createFileRoute("/admin/org-plan/$orgId")({
  head: () => ({ meta: [{ title: "Plan & entitlements · Admin · Malfak" }] }),
  component: OrgPlanRoute,
});

function OrgPlanRoute() {
  const { orgId } = Route.useParams();
  return <AdminOrgPlanPage key={orgId} orgId={orgId} />;
}
